export class ContaRef {
  idContaRef?: number;
  bairro?: string;
  cep?: string;
  cidade?: string;
  email?: string;
  estado?: string;
  num?: string;
  rua?: string;
  nome?: string;
  cnpj?: string;
  codigoBanco?: string;
  codigoCedente?: number;
  digitoCodigoCedente?: string;
  codigoAgencia?: number;
  digitoAgencia?: string;
  numeroConta?: string;
  digitoConta?: string;
  carteira?: string;
  contrato?: string;
  convenio?: number;
  tamConvenio?: number;
  nBoleto?: string;
  nLote?: string;
  car?: string;
  conv?: string;
  tamConv?: number;
  nnBoleto?: string;
  padrao?: string;
  locPagamento?: string;
  inst1?: string;
  inst2?: string;
  carne?: string;
  mensDesc?: string;
  tDesc?: string;
  menstx?: string;
  taxa?: number;
  pMulta?: number;
  pJuro?: number;
  remessa?: string;
  cnab?: string;
  pastaRemessa?: string;
  pastaRetorno?: string;
  ok?: string;
  ativo?: string;
  fpBoleto?: string;
  fpAntecipa?: string;
  historico?: string;
  tipoDoc?: string;
  planoConta?: string;
  fornecedor?: string;
  valorBruto?: number;
  aceite?: string;
}
